import { env } from 'config/env';
import type { DictaphoneDeviceFingerprint } from 'generated/graphql';
import {
  SPEECHMIKE_III_DEFAULT_KEY_MAPPING,
  SPEECHMIKE_III_DEADMAN_SWITCH_KEYCODE,
} from './speechmike';
import type { DictaphoneKeyMapping, DictaphoneProduct } from './types';

const SPEECHMIKE_MATCH_TOKEN = 'speechmike';

export const isVirtualDictaphoneEnabled = () =>
  env.NODE_ENV === 'development' || env.TEST === 'true' || env.E2E_TEST === 'true';

export const isVirtualDictaphoneAudioInputEnabled = () =>
  env.NODE_ENV === 'development' || env.E2E_TEST === 'true';

export const VIRTUAL_DICTAPHONE_AUDIO_INPUT_DEVICE_ID = 'virtual-dictaphone-dev';
export const VIRTUAL_DICTAPHONE_AUDIO_INPUT_LABEL = 'Virtual Dictaphone (Dev)';

const isVirtualDictaphoneFingerprint = ({
  deviceLabel,
  productName,
}: DictaphoneDeviceFingerprint) => {
  const label = deviceLabel?.toLowerCase() ?? '';
  const name = productName?.toLowerCase() ?? '';
  const normalizedFingerprint = `${label} ${name}`.trim();

  if (normalizedFingerprint === '') {
    return false;
  }

  // Keep SpeechMike fingerprints associated with their dedicated product.
  return !label.includes(SPEECHMIKE_MATCH_TOKEN) && !name.includes(SPEECHMIKE_MATCH_TOKEN);
};

export const VIRTUAL_DICTAPHONE_DEADMAN_SWITCH_KEYCODE = SPEECHMIKE_III_DEADMAN_SWITCH_KEYCODE;

export const VIRTUAL_DICTAPHONE_DEFAULT_KEY_MAPPING =
  SPEECHMIKE_III_DEFAULT_KEY_MAPPING satisfies DictaphoneKeyMapping;

const VIRTUAL_DICTAPHONE_BUTTONS = [
  { name: 'Ctrl+1', keyCode: 0 },
  { name: 'Ctrl+2', keyCode: 5 },
  { name: 'Ctrl+3', keyCode: 2 },
  { name: 'Ctrl+4', keyCode: 14 },
  { name: 'Ctrl+5', keyCode: 7 },
  {
    name: 'Ctrl+6',
    keyCode: Number(VIRTUAL_DICTAPHONE_DEADMAN_SWITCH_KEYCODE),
  },
] as const;

export const VIRTUAL_DICTAPHONE_PRODUCT: DictaphoneProduct = {
  id: 'virtual-dictaphone-dev',
  displayName: 'Virtual Dictaphone (Dev)',
  matchesDeviceFingerprint: (fingerprint) =>
    isVirtualDictaphoneEnabled() && isVirtualDictaphoneFingerprint(fingerprint),
  defaultKeyMapping: VIRTUAL_DICTAPHONE_DEFAULT_KEY_MAPPING,
  buttons: VIRTUAL_DICTAPHONE_BUTTONS,
};

export const toMediaStreamDeviceId = (deviceId: string) =>
  deviceId === VIRTUAL_DICTAPHONE_AUDIO_INPUT_DEVICE_ID ? 'default' : deviceId;
